/* eslint-disable @typescript-eslint/camelcase */
import { gAnalytics } from "../config";

window.dataLayer = window.dataLayer || [];

window.dataLayer.push({
  event: "data_export"
});

window.dataLayer.push({
  event: "reset_data"
});

export default function gtag() {
  // eslint-disable-next-line
  dataLayer.push(arguments);
}

export function gTagInit() {
  gtag("js", new Date());

  gtag("config", gAnalytics.nl.id, {
    anonymize_ip: true,
    app_name: gAnalytics.nl.name
  });
  gtag("config", gAnalytics.com.id, {
    anonymize_ip: true,
    app_name: gAnalytics.com.name
  });
}
